import { forwardRef, ReactNode } from "react";

interface FormProps {
  id: string;
  fields: string[],
  onValidSubmit: (model: object) => void;
  onChange: () => void;
  className?: string;
  children: ReactNode;
}
const Form = forwardRef((props: FormProps, ref) => {
  const {
    id, fields, onValidSubmit, onChange, className,
  } = props;

  function handleFormSubmit(e) {
    e.preventDefault();
    if (!onValidSubmit) {
      return;
    }

    const { elements } = ref.current;
    const model = Object.fromEntries(fields.map((name) => [name, elements[name]?.value]));
    onValidSubmit(model);
  }

  return (
    <form id={id} className={className} ref={ref} onSubmit={handleFormSubmit} onChange={onChange}>
      {props.children}
    </form>
  );
});
Form.displayName = "Form";

export default Form;
